<template>
  <div class="flex rounded-lg p-0.5 w-[5.5rem] items-center md:mx-auto odd:bg-white quantity" :class="{'!bg-red-custom-2': product.stock_status !== 'in_stock','pointer-events-none opacity-80': ['stop_selling','change_price'].includes(product.stock_status) }">
    <button type="button" class="btn btn-ghost btn-square btn-xs border-0" :class="[product.stock_status === 'in_stock' ? 'bg-gray-custom-6' : 'bg-white']" @click.stop="changeQuantity(product.quantity + 1)">
      <PlusIcon class="w-4 h-4" :class="[product.stock_status === 'out_stock' ? 'text-error' : 'text-success']" />
    </button>
    <input type="number" @click.stop="$event.target.value = ''" dir="ltr" class="bg-transparent outline-none w-full h-5 text-center text-sm md:text-base cursor-text label-quantity flex items-center justify-center"
      @change.stop="changeQuantity($event.target.value)" :disabled="product.group_sale || 
      product.stock_status == 'out_stock'" @keyup="checkValue" @blur="checkEmpty"
      :class="[product.stock_status === 'out_stock' ? 'text-white' : 'text-gray-custom-1']" :value="product.quantity">
    <button type="button" class="btn btn-square btn-ghost btn-xs border-0" :class="[product.stock_status === 'in_stock' ? 'bg-gray-custom-6' : 'bg-white']" @click.stop="changeQuantity(product.quantity - 1)">
      <MinusIcon class="w-4 h-4 text-error" />
    </button>
  </div>
</template>
<script setup>
import {
  PlusIcon,
  MinusIcon
} from '@heroicons/vue/24/outline'
const props = defineProps(['product','max','min']);
const emit = defineEmits(['change']);
const changeQuantity = (quantity) => {
  if(quantity < 0 || (typeof props.max === "number" && quantity > props.max) || (typeof props.min === "number" && quantity < props.min)) return;
  emit('change', props.product, parseInt(quantity));
}
const setListener = () => {
  if(props.product.stock_status === 'out_stock') return true;
  document.querySelector('input#quantity').checked = true;
  const modal = document.getElementById('modal-quantity');
  modal.querySelector('input').value = props.product.quantity;
  const setQuantity = () => {
    btnAdd.removeEventListener('click', this, false);
    const value = modal.querySelector('input').value;
    if(value)changeQuantity(parseInt(value));
  };
  const btnAdd = modal.querySelector('.btn-add');
  btnAdd.addEventListener('click', setQuantity);
};
const checkValue = (e) => {
  const value = e.target.value.replace(/[^0-9]/g,'');
  e.target.value = value ? parseInt(value) : '';
};
const checkEmpty = (e) => {
  if(!e.target.value) e.target.value = props.product.quantity;
};
</script>